var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRolling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65049 15.75L4.22772 14.75L2 14.25C3.59687 16.6412 6.58154 18.25 10 18.25C13.4185 18.25 16.4031 16.6412 18 14.25L15.7722 14.75L16.3494 15.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8613 13.1931C9.26785 13.0357 8.16986 12.6891 7.12278 12.0725C6.06767 11.4511 5.15235 10.6084 4.77303 9.4948C4.76014 9.45699 4.75 9.40157 4.75 9.32479V5.99147C4.75 5.70755 4.90832 5.44994 5.1601 5.32226C6.29296 4.74779 8.34574 3.70466 9.64214 3.03305C9.86658 2.91678 10.1334 2.91678 10.3579 3.03305C11.6543 3.70466 13.707 4.74779 14.8399 5.32226C15.0917 5.44994 15.25 5.70755 15.25 5.99147V9.32479C15.25 9.40157 15.2399 9.45699 15.227 9.4948C14.8476 10.6084 13.9323 11.4511 12.8772 12.0725C11.8301 12.6891 10.7321 13.0357 10.1387 13.1931C10.0471 13.2174 9.95288 13.2174 9.8613 13.1931Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3V1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRolling);
export default __webpack_public_path__ + "static/media/icon_rolling.2b2e524bb7460a3c2269a1b1ae24ff50.svg";
export { ForwardRef as ReactComponent };